import { render, staticRenderFns } from "./TabLoading.vue?vue&type=template&id=60f20a6d&scoped=true&"
import script from "./TabLoading.vue?vue&type=script&lang=ts&"
export * from "./TabLoading.vue?vue&type=script&lang=ts&"
import style0 from "./TabLoading.vue?vue&type=style&index=0&id=60f20a6d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f20a6d",
  null
  
)

export default component.exports